import React, { useEffect, useState } from 'react';
import { CheckCircle, ShoppingBag } from 'lucide-react';
const RECENT_BUYERS = [{
  name: 'Juan',
  city: 'Salta'
}, {
  name: 'María',
  city: 'Neuquén'
}, {
  name: 'Pablo',
  city: 'Santa Fe'
}, {
  name: 'Carlos',
  city: 'Córdoba'
}, {
  name: 'Ana',
  city: 'Mendoza'
}, {
  name: 'Diego',
  city: 'Buenos Aires'
}, {
  name: 'Roberto',
  city: 'Rosario'
}, {
  name: 'Lucía',
  city: 'Tucumán'
}, {
  name: 'Miguel',
  city: 'Mar del Plata'
}, {
  name: 'Sofía',
  city: 'La Plata'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState(RECENT_BUYERS[0]);
  useEffect(() => {
    const showPopup = () => {
      // Select random buyer
      const randomBuyer = RECENT_BUYERS[Math.floor(Math.random() * RECENT_BUYERS.length)];
      setBuyer(randomBuyer);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    // Random interval between 8-15 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.random() * (15000 - 8000) + 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 z-50 animate-slide-in-right max-w-sm w-full" data-id="element-242">
      <div className="bg-white rounded-lg shadow-xl border-l-4 border-green-500 p-4 flex items-center gap-3" data-id="element-243">
        <div className="bg-green-100 p-2 rounded-full" data-id="element-244">
          <ShoppingBag className="w-5 h-5 text-green-600" data-id="element-245" />
        </div>
        <div data-id="element-246">
          <p className="text-sm font-medium text-gray-900" data-id="element-247">
            <span className="font-bold" data-id="element-248">{buyer.name}</span> de {buyer.city}
          </p>
          <p className="text-xs text-gray-500 flex items-center gap-1" data-id="element-249">
            acaba de comprar KIT CARPINTERÍA PRO
            <CheckCircle className="w-3 h-3 text-green-500" data-id="element-250" />
          </p>
        </div>
      </div>
    </div>;
}